import useDomainCountryCode from "@/hooks/useDomainCountryCode";
import { localizeText } from "@/utils/localizeText";

import SectionWrapper from "@/components/SectionWrapper";

const HARDCODED_SEO_CITIES = [
  {
    count: 25,
    label: "Los Angeles, CA",
    link: "/shop?location=los-angeles-ca-us",
  },
  { count: 14, label: "San Diego, CA", link: "/shop?location=san-diego-ca-us" },
  { count: 22, label: "Anaheim, CA", link: "/shop?location=anaheim-ca-us" },
  { count: 16, label: "Portland, ME", link: "/shop?location=portland-me-us" },
  { count: 2, label: "Boston, MA", link: "/shop?location=boston-ma-us" },
  { count: 17, label: "Detroit, MI", link: "/shop?location=detroit-mi-us" },
  { count: 11, label: "Ann Arbor, MI", link: "/shop?location=ann-arbor-mi-us" },
  { count: 10, label: "Phoenix, AZ", link: "/shop?location=phoenix-az-us" },
  { count: 7, label: "Mesa, AZ", link: "/shop?location=mesa-az-us" },
  { count: 12, label: "Las Vegas, NV", link: "/shop?location=las-vegas-nv-us" },
  { count: 11, label: "Portland, OR", link: "/shop?location=portland-or-us" },
  { count: 20, label: "Toronto, Ont.", link: "/shop?location=toronto-on-ca" },
];

const SEOCityLinks = () => {
  const countryCode = useDomainCountryCode();

  // TODO this could eventually be pulled from Directus.
  const cities = HARDCODED_SEO_CITIES;

  return cities?.length ? (
    <SectionWrapper
      title="Shop the best weed near you"
      subtitle="Shop pickup and delivery for local, legal weed, anywhere you are."
      changeLocation={false}
      className="container"
    >
      <div className="row -mb-lg mt-md">
        {cities.map(({ label, link, count }, i) => (
          <div
            className="col-1/2 md:col-1/4 lg:col-1/6 mb-lg"
            key={`${label}-${i}`}
          >
            {/* These need to be anchor tags, not Link components, otherwise Next tries to shallow navigate, which is wonky given all our convoluted redirecting logic currently in place. */}
            <a
              href={link}
              className="flex flex-col justify-between rounded shadow-low bg-white p-md h-full"
              data-testid="seo-cities-section-card"
            >
              <h3 className="text-green font-bold text-sm">{label}</h3>
              <p className="mb-none text-xs">{`${count} ${
                Number(count) === 1
                  ? localizeText("dispensary", countryCode)
                  : localizeText("dispensaries", countryCode)
              }`}</p>
            </a>
          </div>
        ))}
      </div>
    </SectionWrapper>
  ) : null;
};

export default SEOCityLinks;
